import React from 'react';
import { Card } from '../../Library/Card';
import { Grid, Typography } from '@mui/material';
import { RootineImage } from '../../../atoms/RootineImage';

export type ArticleContent = {
  title: string;
  imgSrc: string;
  href: string;
};

export type RelatedContentProps = {
  title: string;
  content: ArticleContent[];
};

export const StressRelatedContent = ({
  relatedContent,
}: {
  relatedContent: RelatedContentProps;
}): JSX.Element => {
  return (
    <Card
      content={
        <>
          <Typography variant="medium" fontSize={18} sx={{ mb: 0.5 }}>
            {relatedContent.title}
          </Typography>
          <Typography variant="light" fontSize={14} sx={{ mb: 4 }}>
            Deepen your understanding with these related reads
          </Typography>
          <Grid container flexDirection="column" alignItems="center" gap={4}>
            {relatedContent.content.map(
              (content: ArticleContent, index: number) => (
                <Grid
                  container
                  flexDirection="column"
                  item
                  xs={12}
                  component="a"
                  href={content.href}
                  target="_blank"
                  key={`${content.title}-${index}`}
                >
                  <RootineImage
                    src={content.imgSrc}
                    alt={content.title}
                    height={200}
                  />

                  <Typography variant="medium" fontSize={18} sx={{ mt: 1 }}>
                    {content.title}
                  </Typography>
                </Grid>
              )
            )}
          </Grid>
        </>
      }
      cardStyles={{ mt: 3 }}
    />
  );
};
